import { createFileRoute } from "@tanstack/react-router";
import { CashAccounts } from "@/components/CashAccounts";

function RouteComponent() {
  return <CashAccounts />;
}

export const Route = createFileRoute("/_authenticated/cash-accounts/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
